import { render, staticRenderFns } from "./TextEditorsTiny.vue?vue&type=template&id=d48e0160&scoped=true"
import script from "./TextEditorsTiny.vue?vue&type=script&lang=js"
export * from "./TextEditorsTiny.vue?vue&type=script&lang=js"
import style0 from "./TextEditorsTiny.vue?vue&type=style&index=0&id=d48e0160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48e0160",
  null
  
)

export default component.exports